import { useState } from 'react';
import { deletePlantillaCobranza } from '../../helpers/api_helper';
import { useSelector } from 'react-redux';


const useDeletePlantilla = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const tenantId = useSelector((state) => state.Context.tenantId);

    const deletePlantilla = async (id) => {
        setLoading(true);
        setError(null);
        try {
            const response = await deletePlantillaCobranza(id, tenantId);
            return response;
        } catch (err) {
            const errorMessage = `Failed to delete plantilla: ${err.message || 'Unknown error'}`;
            setError(errorMessage);
            throw new Error(errorMessage);
        } finally {
            setLoading(false);
        }
    };

    return { deletePlantilla, loading, error };
};

export default useDeletePlantilla;